import { Typography } from '@kizen/kds/Typography';
import { useEffect, useMemo } from 'react';
import { usePluginSafeHTML, useSetupAssistant } from '@kizenapps/engine/react';
import { AssistantField } from '@kizenapps/engine';
import { markdownToHtmlSync } from '@kizen/parse-md';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  &:last-child {
    margin-bottom: 5px;
  }
`;

const Markdown = styled.span`
  &,
  * {
    line-height: inherit;
  }

  p,
  ul,
  ol {
    margin: 0;
  }

  p + p,
  p + ul,
  p + ol,
  ul + p,
  ol + p {
    margin-top: 10px;
  }
`;

export const DescriptionBlock = ({ field }: { field: AssistantField }) => {
  const { evaluateExpression, shouldHideField } = useSetupAssistant();

  useEffect(() => {
    if (field.when) {
      evaluateExpression(field.when, field.key);
    }
  }, [field.when, evaluateExpression, field.key]);

  const parsedMarkDown = useMemo(
    () =>
      markdownToHtmlSync(field.content ?? '', { forceExternalLinks: false }),
    [field.content]
  );

  const { html } = usePluginSafeHTML(parsedMarkDown);

  if (shouldHideField(field.key)) {
    return null;
  }

  return (
    <Wrapper>
      <Typography color="font-primary">
        <Markdown dangerouslySetInnerHTML={{ __html: html }} />
      </Typography>
    </Wrapper>
  );
};
